<template>
  <div style="width: 100%;">
    <v-row>
      <v-col>
        <v-container>
          <v-row>
            <v-col class="d-flex flex-row align-center">
              <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
              <h1>{{this.plural}}</h1>
              <v-progress-circular
                  indeterminate
                  color="green"
                  v-if="loader"
                  style="margin-left: 10px;"
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                  :headers="headers"
                  :items="data"
                  :items-per-page="-1"
                  class="elevation-1"
                  @click:row="rowClick"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col v-if="isAllowed('productCategory','c')" cols="4">
        <v-container>
          <v-row>
            <v-col class='d-flex flex-row align-center'>
              <h1>Add New {{this.singular}}</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                  label="Name"
                  outlined
                  v-model="category.name"
              />
              <v-text-field
                  label="Slug"
                  outlined
                  v-model="category.slug"
                  persistent-hint
                  hint="Spaces within the Slug will be replaced with '-' automatically."
              />
              <v-text-field
                  label="Description"
                  outlined
                  v-model="category.description"
              />
              <v-autocomplete
                  item-text="name"
                  return-object
                  :items="data"
                  label="Parent Category"
                  outlined
                  v-model="category.parent"
              />
              <v-text-field
                  label="Image"
                  outlined
                  v-model="category.image"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn @click="create" :disabled="!this.category.name">Create</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";

  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,

        snackObj: {
          state: false,
          color: '',
          text: ''
        },

        max25chars: v => v.length <= 25 || 'Input too long!',
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'familyName',
          },
          { text: 'Slug', value: 'slug', sortable: true },
          { text: 'Description', value: 'description' },
          { text: 'Count', value: 'count' },
        ],
        editMode: false,
        data: [],
        category: {},
        singular: "Product Category",
        singularLower: "productcategory",
        plural: "Product Categories",
        pluralLower: "productcategories"
      }
    },
    async mounted(){
        await this.getAllData();
    },
    computed: {
      ...mapGetters(['getEndpoint', "isAllowed"])
    },
    methods: {
      rowClick(row){
        this.$router.push({ path: `/${this.pluralLower}/view/${row.id}`})
      },
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      async create(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.category)
          if(res.data.error) throw res.data.error

          if(res.data.data.created){
            this.snack(`${this.singular} Created 🎉`, "success");
            this.category={};
            await this.getAllData();
          }
          else{
            this.snack(`${this.singular} Already Exists 🎉`);
          }
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        }
      },
      async getAllData(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}`)
          if(res.data.error) throw res.data.error

          this.data = res.data.data

          let formattedCategories = [];

          this.data.forEach(category => {
            let familyName = "";

            if(category.parent!==null){
              let parentPath = "";
              let currParent = category.parent;
              while(currParent!==null){
                let parent = this.data.find(i => currParent===i.id);
                if(parent){
                  parentPath = parent.name+">"+parentPath;
                  currParent = parent.parent;
                }
                else{
                  break;
                }
              }
              familyName=parentPath;
            }
            familyName+=category.name;

            category.familyName = familyName;

            formattedCategories.push(category);
          });

          formattedCategories.sort((a, b) => {
            return (a.familyName.toLowerCase() > b.familyName.toLowerCase()) ? 1 : -1
          });

          //formattedCategories.splice(0, 0, uncat);

          this.data = formattedCategories;
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      }
    }
  }
</script>
